<template>

  <div>
    <v-card class="ma-1" outlined style="height: 165px">
      <v-card-title style="height: 64px">
        Adresă
        <v-spacer/>
        <v-btn x-small fab depressed color="primary" @click="dialog=!dialog">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider class="mx-4"/>

      <v-card-text style="height: 98px;">

        <template v-if="!hotel.static.location.address.street">
          <v-alert dark color="error">
            <v-row no-gutters align="center">
              <v-icon left>mdi-alert</v-icon>
              Adresa nu este completată.
            </v-row>
          </v-alert>
        </template>

        <template v-else>
          <v-row no-gutters>
            <v-col cols="12">{{hotel.static.location.address.street}}</v-col>
            <v-col cols="12">{{hotel.static.location.address.city}}, {{hotel.static.location.address.region}}</v-col>
            <v-col cols="12">{{hotel.static.location.address.postcode}}</v-col>
          </v-row>
        </template>

      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" width="960">
      <v-card>

        <v-toolbar class="primary white--text" flat dark>
          <v-toolbar-title>Adresă</v-toolbar-title>
          <v-spacer/>
          <v-btn icon @click="cancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-3">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">
                Geolocalizare
              </div>
            </v-col>
            <v-col cols="12">
              <gmap-autocomplete @place_changed="setAddress($event)">
                <template v-slot:input="{ on }">
                  <v-text-field
                    v-on="on"
                    class="ma-1"
                    prepend-inner-icon="mdi-map-marker"
                    placeholder="Introduceti o adresă ..."
                    ref="input"
                    hide-details
                    outlined
                    dense
                  />
                </template>
              </gmap-autocomplete>
            </v-col>
            <v-col cols="12">
              <GmapMap :center="position" :zoom="15" :options="gMapOptions" style="height: 350px;" class="ma-1">
                <GmapMarker v-model="position" :position="position" :clickable="false" :draggable="true" @dragend="setMarker($event)"/>
              </GmapMap>
            </v-col>
            <v-col cols="12">
              <div class="subtitle-1 font-weight-bold ma-1">
                Adresă
              </div>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="hotel.static.location.address.country" class="ma-1" label="Țară" outlined dense hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="hotel.static.location.address.region" class="ma-1" label="Județ" outlined dense hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="hotel.static.location.address.city" class="ma-1" label="Oraș" outlined dense hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="hotel.static.location.address.street" class="ma-1" label="Strada" outlined dense hide-details/>
            </v-col>
            <v-col cols="2">
              <v-text-field v-model="hotel.static.location.address.number" class="ma-1" label="Numar" outlined dense hide-details/>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="hotel.static.location.address.details" class="ma-1" label="Detalii suplimentare" dense outlined hide-details/>
            </v-col>
            <v-col cols="2">
              <v-text-field v-model="hotel.static.location.address.postcode" class="ma-1" label="Cod Postal" dense outlined hide-details/>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="mx-2"/>

        <v-card-actions>
          <v-btn color="primary" text @click="cancel">
            Anuleaza
          </v-btn>
          <v-spacer/>
          <v-btn color="primary" depressed @click="save">
            Salveaza
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>

  import gmap_repository from '@/repositories/gmap-repository'

  export default {

    props: {
      hotel: Object
    },

    created() {
      this.position = {
        lat: Number(this.hotel.static.location.geo.lat),
        lng: Number(this.hotel.static.location.geo.lon)
      };
    },

    data: () => ({
      dialog: false,
      position: null,
      address: null,

      gMapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: true
      }

    }),

    methods: {

      save() {
        this.dialog = false;
        this.$emit('save')
      },

      cancel() {
        this.$emit('cancel');
        this.dialog = false;
      },

      setAddress(event) {

        this.position = {
          lat: event.geometry.location.lat(),
          lng: event.geometry.location.lng()
        };

        this.hotel.static.location.geo = {
          lat: this.position.lat,
          lon: this.position.lng
        };

        event.address_components.forEach((place) => {
          this.populateInfo(place)
        });
      },

      async setMarker(event) {

        this.position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng()
        };

        this.hotel.static.location.geo = {
          lat: this.position.lat,
          lon: this.position.lng
        };

        let address_components = await gmap_repository.getAddressComponents(event);
        address_components.forEach((place) => {
          this.populateInfo(place)
        });
      },

      populateInfo(place) {
        place.types.forEach(function (item) {

          switch (item) {
            case "street_number":
              this.hotel.static.location.address.number = place.long_name;
              break;

            case "route":
              this.hotel.static.location.address.street = place.long_name;
              break;

            case "locality":
              this.hotel.static.location.address.city = place.long_name;
              break;

            case "administrative_area_level_1":
              this.hotel.static.location.address.region = place.long_name;
              break;

            case "country":
              this.hotel.static.location.address.country = place.short_name;
              break;

            case "postal_code":
              this.hotel.static.location.address.postcode = place.long_name;
              break;
          }

        }.bind(this));
      }

    }

  }
</script>